import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Modal,
  IconButton,
  TablePagination,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { getWorkflows, deleteWorkflow } from "../../api/api";

const WorkflowListPage = () => {
  const [workflows, setWorkflows] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const navigate = useNavigate();

  useEffect(() => {
    fetchWorkflows();
  }, [page, rowsPerPage]);

  const fetchWorkflows = async () => {
    try {
      const response = await getWorkflows({ page: page + 1, limit: rowsPerPage });
      setWorkflows(response.data.data);
      setTotalCount(response.data.total); // Assuming the API returns total count
    } catch (error) {
      console.error("Error fetching workflows:", error);
    }
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const handleRowsPerPageChange = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0); // Reset to the first page
  };

  const handleDelete = async (id) => {
    try {
      await deleteWorkflow(id);
      fetchWorkflows(); // Refresh the list after deletion
    } catch (error) {
      console.error("Error deleting workflow:", error);
    }
  };

  return (
    <Box sx={{ padding: 4 }}>
      <Typography variant="h4" gutterBottom>
        Workflows
      </Typography>
      <IconButton
        color="primary"
        onClick={() => navigate("/create-workflow")}
        sx={{ marginBottom: 2 }}
      >
        <Typography variant="button">Add Workflow</Typography>
      </IconButton>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Name</TableCell>
              <TableCell>Description</TableCell>
              <TableCell>Type</TableCell>
              <TableCell>Assets/Asset Type</TableCell>
              <TableCell>Events</TableCell>
              <TableCell>Actions</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Manage</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {workflows.map((workflow) => (
              <TableRow key={workflow._id}>
                <TableCell>{workflow.name}</TableCell>
                <TableCell>{workflow.description}</TableCell>
                <TableCell>{workflow.type}</TableCell>
                <TableCell>
                  {workflow.type === "global"
                    ? workflow.assetType || "Not Specified"
                    : workflow.assets && workflow.assets.length > 0
                    ? workflow.assets
                        .map(
                          (asset) =>
                            `${asset.assetType} (${asset.assetId["Location Name"] || asset.assetId})`
                        )
                        .join(", ")
                    : "No Assets"}
                </TableCell>
                <TableCell>
                  {workflow.events.length > 0
                    ? workflow.events.map((event) => event.type).join(", ")
                    : "No Events"}
                </TableCell>
                <TableCell>
                  {workflow.actions.length > 0
                    ? workflow.actions.map((action) => action.name).join(", ")
                    : "No Actions"}
                </TableCell>
                <TableCell>
                  {workflow.status === "enabled" ? "Enabled" : "Disabled"}
                </TableCell>
                <TableCell>
                <IconButton
                      color="primary"
                      onClick={() => navigate(`/workflow/${workflow._id}`)}
                    >
                      <VisibilityIcon />
                    </IconButton>
                  <IconButton
                    color="primary"
                    onClick={() => navigate(`/edit-workflow/${workflow._id}`)}
                  >
                    <EditIcon />
                  </IconButton>
                  <IconButton
                    color="error"
                    onClick={() => handleDelete(workflow._id)}
                  >
                    <DeleteIcon />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        <TablePagination
          component="div"
          count={totalCount}
          page={page}
          onPageChange={handlePageChange}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={handleRowsPerPageChange}
        />
      </TableContainer>
    </Box>
  );
};

export default WorkflowListPage;
